import { useEffect } from 'react';
import { FormikProps, FormikValues, useFormik } from 'formik';
import { AnyObjectSchema } from 'yup';

type Options<T extends FormikValues> = {
    initialValues: T;
    validationSchema: AnyObjectSchema;
    onChangeFormik?: (formik: FormikProps<T>) => void;
    readOnly?: boolean;
    seedValues?: T;
};

export const useOrbitFormSection = <T extends FormikValues>({
    initialValues,
    validationSchema,
    onChangeFormik,
    readOnly,
    seedValues,
}: Options<T>) => {
    const formik = useFormik<T>({
        initialValues: {
            ...initialValues,
            ...(readOnly && seedValues ? seedValues : {}),
        },
        validationSchema,
        enableReinitialize: readOnly,
        onSubmit: () => undefined,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors, formik.isValid]);

    return { formik };
};
